const API = (process.env.REACT_APP_BACKEND_URL && process.env.REACT_APP_BACKEND_URL !== '')
  ? process.env.REACT_APP_BACKEND_URL
  : '';

function authHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function readError(res) {
  try {
    const body = await res.json();
    const detail = body?.detail;
    if (typeof detail === 'string') return detail;
    return body?.message || `Request failed (${res.status})`;
  } catch {
    return `Request failed (${res.status})`;
  }
}

async function npFetch(path, options = {}) {
  const res = await fetch(`${API}${path}`, {
    ...options,
    headers: {
      ...authHeaders(),
      ...(options.body && !(options.body instanceof FormData) ? { 'Content-Type': 'application/json' } : {}),
      ...(options.headers || {}),
    },
  });
  if (!res.ok) {
    const err = new Error(await readError(res));
    err.status = res.status;
    throw err;
  }
  return res.json();
}

export const neveroverpayApi = {
  meta: () => npFetch('/api/neveroverpay/meta'),
  agents: () => npFetch('/api/neveroverpay/agents'),
  listCases: () => npFetch('/api/neveroverpay/cases'),
  getCase: (id) => npFetch(`/api/neveroverpay/cases/${id}`),
  graph: () => npFetch('/api/neveroverpay/graph'),
  approve: (id, content_hash) => npFetch(`/api/neveroverpay/cases/${id}/approve`, {
    method: 'POST',
    body: JSON.stringify({ content_hash }),
  }),
  markSent: (id) => npFetch(`/api/neveroverpay/cases/${id}/mark-sent`, { method: 'POST' }),
  confirm: (id, payload) => npFetch(`/api/neveroverpay/cases/${id}/confirm-outcome`, {
    method: 'POST',
    body: JSON.stringify(payload),
  }),
  dismiss: (id) => npFetch(`/api/neveroverpay/cases/${id}/dismiss`, {
    method: 'POST',
    body: JSON.stringify({ outcome: 'USER_DISMISSED' }),
  }),
    ledger: () => npFetch('/api/neveroverpay/ledger'),
  opsQueue: () => npFetch('/api/neveroverpay/ops/queue'),
  opsAudit: () => npFetch('/api/neveroverpay/ops/audit'),
  savePlaybook: (row) => npFetch('/api/neveroverpay/ops/playbooks', {
    method: 'PUT',
    body: JSON.stringify(row),
  }),
  sendApproved: (id) => npFetch(`/api/neveroverpay/cases/${id}/send`, { method: 'POST' }),
  merchantReply: (id, text) => npFetch(`/api/neveroverpay/cases/${id}/merchant-reply`, {
    method: 'POST',
    body: JSON.stringify({ text }),
  }),
  attachProof: (id, text) => npFetch(`/api/neveroverpay/cases/${id}/proof`, {
    method: 'POST',
    body: JSON.stringify({ text }),
  }),
  adminAccess: () => npFetch('/api/neveroverpay/admin/access'),
  adminBootstrap: () => npFetch('/api/neveroverpay/admin/bootstrap', { method: 'POST' }),
  adminSettings: () => npFetch('/api/neveroverpay/admin/settings'),
  saveAdminSettings: (patch) => npFetch('/api/neveroverpay/admin/settings', {
    method: 'PUT',
    body: JSON.stringify(patch),
  }),
  testEmail: () => npFetch('/api/neveroverpay/admin/test-email', { method: 'POST' }),
  adminHealth: () => npFetch('/api/neveroverpay/admin/health'),
  autonomyTick: () => npFetch('/api/neveroverpay/admin/autonomy/tick', { method: 'POST' }),
  deadlineSweep: () => npFetch('/api/neveroverpay/admin/deadline-sweep', { method: 'POST' }),
  gmailStatus: () => npFetch('/api/neveroverpay/gmail/status'),
  gmailConnectUrl: (send = false) => npFetch(`/api/neveroverpay/gmail/connect-url${send ? '?send=true' : ''}`),
  gmailCallback: ({ code, state }) => npFetch('/api/neveroverpay/gmail/callback', {
    method: 'POST',
    body: JSON.stringify({ code, state }),
  }),
  gmailDisconnect: () => npFetch('/api/neveroverpay/gmail/disconnect', { method: 'POST' }),
  gmailSync: () => npFetch('/api/neveroverpay/gmail/sync', { method: 'POST' }),
  analytics: () => npFetch('/api/neveroverpay/analytics'),
  tracker: () => npFetch('/api/neveroverpay/tracker'),
  caseTracker: (id) => npFetch(`/api/neveroverpay/cases/${id}/tracker`),
  digestSettings: () => npFetch('/api/neveroverpay/digest/settings'),
  saveDigestSettings: (patch) => npFetch('/api/neveroverpay/digest/settings', {
    method: 'PUT',
    body: JSON.stringify(patch),
  }),
  digestPreview: () => npFetch('/api/neveroverpay/digest/preview'),
  digestSendNow: () => npFetch('/api/neveroverpay/digest/send-now', { method: 'POST' }),
  onboardingIntents: (intents) => npFetch('/api/neveroverpay/onboarding/intent', {
    method: 'PUT',
    body: JSON.stringify({ intents }),
  }),
  onboarding: () => npFetch('/api/neveroverpay/onboarding'),
  onboardingStep: (step) => npFetch('/api/neveroverpay/onboarding/step', {
    method: 'PUT',
    body: JSON.stringify({ step }),
  }),
  onboardingIntent: (intent) => npFetch('/api/neveroverpay/onboarding/intent', {
    method: 'PUT',
    body: JSON.stringify({ intent }),
  }),
  onboardingInbox: (choice) => npFetch('/api/neveroverpay/onboarding/inbox', {
    method: 'PUT',
    body: JSON.stringify({ choice }),
  }),
  onboardingBank: (choice) => npFetch('/api/neveroverpay/onboarding/bank', {
    method: 'PUT',
    body: JSON.stringify({ choice }),
  }),
  onboardingPolicy: (policy) => npFetch('/api/neveroverpay/onboarding/policy', {
    method: 'PUT',
    body: JSON.stringify(policy),
  }),
  onboardingScan: () => npFetch('/api/neveroverpay/onboarding/scan', { method: 'POST' }),
  onboardingComplete: () => npFetch('/api/neveroverpay/onboarding/complete', { method: 'POST' }),
  exportHousehold: () => npFetch('/api/neveroverpay/household/export'),
  approveAndSend: (id, content_hash) => npFetch(`/api/neveroverpay/cases/${id}/approve-and-send`, {
    method: 'POST',
    body: JSON.stringify({ content_hash }),
  }),
  selectAction: (id, option, days = 1) => npFetch(`/api/neveroverpay/cases/${id}/select-action`, {
    method: 'POST',
    body: JSON.stringify({ option, days }),
  }),
  remindLater: (id, days = 1) => npFetch(`/api/neveroverpay/cases/${id}/remind-later`, {
    method: 'POST',
    body: JSON.stringify({ days }),
  }),
  renewalChoice: (id, choice) => npFetch(`/api/neveroverpay/cases/${id}/renewal-choice`, {
    method: 'POST',
    body: JSON.stringify({ choice }),
  }),
  overlapDecision: (id, decision, merchant_slug = '') => npFetch(`/api/neveroverpay/cases/${id}/overlap-decision`, {
    method: 'POST',
    body: JSON.stringify({ decision, merchant_slug }),
  }),
  detectors: () => npFetch('/api/neveroverpay/detectors'),
  offerDecision: (id, decision) => npFetch(`/api/neveroverpay/cases/${id}/offer-decision`, {
    method: 'POST',
    body: JSON.stringify({ decision }),
  }),
  notifications: () => npFetch('/api/neveroverpay/notifications'),
  markNotificationRead: (id) => npFetch(`/api/neveroverpay/notifications/${id}/read`, { method: 'POST' }),
  updateAlerts: (payload) => npFetch('/api/neveroverpay/alerts', {
    method: 'PUT',
    body: JSON.stringify(payload),
  }),
  plaidStatus: () => npFetch('/api/neveroverpay/plaid/status'),
  plaidLinkToken: () => npFetch('/api/neveroverpay/plaid/link-token', { method: 'POST' }),
  plaidExchange: (public_token) => npFetch('/api/neveroverpay/plaid/exchange', {
    method: 'POST',
    body: JSON.stringify({ public_token }),
  }),
  plaidSync: () => npFetch('/api/neveroverpay/plaid/sync', { method: 'POST' }),
  deleteHousehold: () => npFetch('/api/neveroverpay/household', { method: 'DELETE' }),
  consents: () => npFetch('/api/neveroverpay/consents'),
  grantConsent: (kind) => npFetch('/api/neveroverpay/consents', {
    method: 'POST',
    body: JSON.stringify({ kind }),
  }),
  revokeConsent: (kind) => npFetch(`/api/neveroverpay/consents/${kind}/revoke`, { method: 'POST' }),
  ingestText: (text, filename = 'pasted.txt') => npFetch('/api/neveroverpay/documents/text', {
    method: 'POST',
    body: JSON.stringify({ text, filename }),
  }),
  inviteMember: (email) => npFetch('/api/neveroverpay/household/members', {
    method: 'POST',
    body: JSON.stringify({ email }),
  }),
  completeTask: (id) => npFetch(`/api/neveroverpay/cases/${id}/complete-task`, { method: 'POST' }),
  household: () => npFetch('/api/neveroverpay/household'),
  upload: async (file) => {
    const body = new FormData();
    body.append('file', file);
    return npFetch('/api/neveroverpay/documents', { method: 'POST', body });
  },
};

export function isLoggedIn() {
  return Boolean(localStorage.getItem('token'));
}

export function signOut() {
  localStorage.removeItem('token');
  localStorage.removeItem('emerge_token_backup');
  window.location.href = '/';
}
